const home = {
    popup: {
        date: 'Новата дата за Осогово Рън е 27 септември 2026!',
        registration: 'Регистрацията ще бъде отворена скоро.',
    },
    footer: 'Copyright © 2025 Osogovo Run',
    route: {
        scrollPrompt: 'Виж повече',
        distance: '{{distance}}km',
        elevation: '{{elevation}} m D+',
        coldSpring: {
            name: 'Студен<br/> Кладенец',
            altitude: '1340 м',
        },
        hut: {
            name: 'хижа<br/> Осогово',
            altitude: '1640 м',
        },
        begBunar: {
            name: 'Бег Бунар',
            altitude: '1842 м',
        },
        ruen: {
            name: 'Руен',
            altitude: '2251 м',
        },
    },
    products: {
        start: 'Старт',
        finish: 'Финал',
        startTime: 'Стартово време',
        totalDistance: 'Обща дистанция',
        elevation: 'Положителна денивелация',
        cutOffTime: 'Контролно време',
        fee: 'Такса',
        lateFee: 'Такса след 17.09.2026',
        register: 'Регистрирай се',
        downloadGpx: 'Кликни за сваляне',
        osogovoRun14: {
            name: 'Осогово рън',
            start: 'пл. Велбъжд, гр. Кюстендил',
            finish: 'х. Осогово',
            startTime: '9:00',
            totalDistance: '14 км',
            elevation: '1100 м',
            cutOffTime: '12:30',
            description: 'Осогово рън е състезание по планинско бягане, което се провежда в Осоговската планина. Състезанието предлага различни дистанции и маршрути, които преминават през живописни пейзажи и предизвикателни терени.',
        },
        ruenRun26: {
            name: 'Осогово ултрамаратон',
            start: 'пл. Велбъжд, гр. Кюстендил',
            finish: 'вр. Руен',
            startTime: '09:00',
            totalDistance: '27 км',
            elevation: '1700 м',
            cutOffTime: '14:30',
            description: 'Руен рън е предизвикателство за опитни бегачи, които искат да се изправят пред дълги дистанции и трудни условия в Осоговската планина. Състезанието предлага уникален опит и възможност за преодоляване на собствените граници.',
        },
    },
    course: {
        title: 'Трасе',
        description: 'Старт на площад Велбъжд в центъра на Кюстендил (530м Н.В.), преминава покрай стадиона, картинг пистата и Почивало, по горски път под х. Иглика до Студен кладенец. Преди м. Памука излиза на асфалтовия път и след 2км достига х. Осогово, откъдето връх Руен се изкачва през Бегбунар по лятната пътека на централното било (червена маркировка). Връщането от върха до хижата е на собствен ход. откъдето е осигурено извозване до града.',
        feesTitle: 'Стартови такси',
        distanceLabel: '{{distance}} км',
        earlyFee: '/ ранна такса',
        regularFee: '/ стандартна такса',
        lateFee: '/ късна такса',
        register: 'Регистрирай се',
    },
    records: {
        title: 'Рекорди на трасето',
        holder: 'Рекордьор',
        time: 'Време',
        bonus: 'Текущ бонус за подобрение на рекорда до връх Руен:',
        note: 'Ако бонусът не бъде присъден тази година, сумата се натрупва към бонуса за следващото издание.',
        male: {
            title: 'Мъже',
        },
        female: {
            title: 'Жени',
        },
    },
    details: {
        conditionsTitle: 'Условия за участие',
        conditions: 'Неограничено, за физически и психически здрави хора от 15 до 75-годишна възраст. Участниците се задължават да се движат по маркировката и да спазват Закона за движение по пътищата преди, по време и след състезанието. Непредставилите на регистрацията предсъстезателен преглед стартират на собствена отговорност. Разходите по участието са за сметка на участниците. Носенето на лична карта за участниците на дългата дистанция по време на състезанието е задължително поради навлизане в гранична зона!',
        transportTitle: 'Транспорт',
        transportFinish: '<b>Извозване след финиширане:</b> от паркинга при хижа Осогово с автобус до старта. Първи курс след 13:00 часа при запълване на местата.',
        transportLuggage: '<b>Транспортиране на багаж:</b> осигурено е транспортиране на багаж на участниците от старта до финала. Същият трябва да бъде предаден на организаторите до 8:50 часа в деня на старта.',
        programTitle: 'Програма за състезателния ден | 27.09.2026',
        programRegistration: '<b>8:00-8:45 ч.</b> Регистрация за участие в зоната на старта',
        programStart: '<b>9:00 ч.</b> СТАРТ на всички дистанции',
        programEnd: '<b>14:30 ч.</b> затваряне на ФИНАЛА',
        contactsTitle: 'Контакти',
        socialsPrompt: 'Последвай ни в социалните ни мрежи:',
    },
};

export default home;
